import Vue from "vue";
import Router from "vue-router";
import pageEdit from "@/page/page-edit";

Vue.use(Router);

export default new Router({
  routes: [{
      path: "/",
      redirect: {name: 'page_edit'}
    }, {
      path: "/editor",
      name: "page_edit",
      component: pageEdit,
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js